import script from "./AssignedJobDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignedJobDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignedJobDetailModal.vue?vue&type=style&index=0&id=c5fd5334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5fd5334"]])

export default __exports__